export default {
    SELECT_FILE: 'selectFile',
    SELECT_FOLDER: 'selectFolder',
    MOVE_COPY: 'moveCopy',
    MULTI_SELECT: 'multiSelect',
};
